import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { PseModelsTransformer } from './pse.transformer';

import { ApiPseBank } from '@api/_api/api-payment/api-pse.model';
import { ApiPseService } from '@api/_api/api-payment/api-pse.service';
import { getStoreAndLanguage } from '@core/infrastructure/state/core.selectors';
import { getOrderId } from '@shared/shopcart/store/shopcart.selectors';

@Injectable()
export class PseService {
    constructor(
        private readonly apiPseService: ApiPseService,
        private readonly store: Store,
    ) {}

    public pseBanks$: Observable<ApiPseBank[]> = combineLatest([
        this.store.select(getOrderId),
        this.store.select(getStoreAndLanguage),
    ]).pipe(
        switchMap(([orderId, storeAndLanguage]) => {
            return this.apiPseService.getPseBanks(storeAndLanguage.storeId, orderId, storeAndLanguage.languageId).pipe(
                map((pseBank)=>{
                    return PseModelsTransformer.PseBanksFromApi(pseBank);
                }),
                catchError((error: unknown) => {
                    console.error(error);
                    return throwError(() => error);
                })
            );
        }),
    );
}
